import { useEffect, useRef } from "react";
import beinsports from "../assets/cover/chaine/Bein_Sports.png";
import mbcgroup from "../assets/cover/chaine/MBC_Group.png";
import netflix from "../assets/cover/chaine/Netflix.png";
import primevideo from "../assets/cover/chaine/Prime_Video.png";
import disney from "../assets/cover/chaine/Disney+.png";
import canalplus from "../assets/cover/chaine/Canal+.png";
import tf1 from "../assets/cover/chaine/TF1.png";
import hbomax from "../assets/cover/chaine/HBO_Max.png";
import w9 from "../assets/cover/chaine/W9.png";
import ocs from "../assets/cover/chaine/OCS.png";
import tf1films from "../assets/cover/chaine/TF1_Films.png";
import appletvplus from "../assets/cover/chaine/Apple_TV.png";
import rmc from "../assets/cover/chaine/RMC.png";
import plutotv from "../assets/cover/chaine/Pluto_TV.png";
import m6 from "../assets/cover/chaine/M6.png";
import hulu from "../assets/cover/chaine/Hulu.png";
import arte from "../assets/cover/chaine/Arte.png";
import dazn from "../assets/cover/chaine/DAZN.png";

export default function Chaine() {
  const carouselRef = useRef(null);
  const scrollInterval = useRef(null);

  // Block any manual scroll/drag while keeping programmatic autoplay
  const blockUserScroll = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  // Import all film images
  const filmImages = [];
  for (let i = 1; i <= 38; i++) {
    try {
      const imagePath =
        i === 8 || i === 19
          ? require(`../assets/cover/film/${i}.jpg`)
          : require(`../assets/cover/film/${i}.webp`);
      filmImages.push(imagePath);
    } catch (error) {
      console.warn(`Could not load image ${i}`);
    }
  }

  // Import all chaine logos
  const chaineLogos = [
    { name: "Bein Sports", src: beinsports },
    { name: "MBC Group", src: mbcgroup },
    { name: "Netflix", src: netflix },
    { name: "Prime Video", src: primevideo },
    { name: "Disney+", src: disney },
    { name: "Canal+", src: canalplus },
    { name: "TF1", src: tf1 },
    { name: "HBO Max", src: hbomax },
    { name: "W9", src: w9 },
    { name: "OCS", src: ocs },
    { name: "TF1 Films", src: tf1films },
    { name: "Apple TV+", src: appletvplus },
    { name: "RMC", src: rmc },
    { name: "Pluto TV", src: plutotv },
    { name: "M6", src: m6 },
    { name: "Hulu", src: hulu },
    { name: "Arte", src: arte },
    { name: "DAZN", src: dazn },
  ];

  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    // Create infinite scroll effect
    const startInfiniteScroll = () => {
      scrollInterval.current = setInterval(() => {
        const singleSetWidth = carousel.scrollWidth / 3; // Since we have 3 copies
        const currentScroll = carousel.scrollLeft;
        
        // Reset to beginning when we've scrolled through one complete set
        if (currentScroll >= singleSetWidth) {
          carousel.scrollLeft = 0;
        } else {
          carousel.scrollLeft += 1;
        }
      }, 20); // Smooth 50fps animation
    };

    // Wait for images to load and carousel to be properly initialized
    const initializeCarousel = () => {
      // Check if all images are loaded
      const images = carousel.querySelectorAll('img');
      const loadedImages = Array.from(images).filter(img => img.complete);
      
      // If all images are loaded or after a reasonable timeout, start the carousel
      if (loadedImages.length === images.length || loadedImages.length > 0) {
        startInfiniteScroll();
      } else {
        // Wait for images to load with a maximum timeout
        setTimeout(() => {
          startInfiniteScroll();
        }, 500);
      }
    };

    // Start initialization after a short delay to ensure DOM is ready
    setTimeout(initializeCarousel, 100);

    return () => {
      if (scrollInterval.current) {
        clearInterval(scrollInterval.current);
      }
    };
  }, []);

  return (
    <>
      <section className="py-16 bg-slate-50">
        <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto">
          <div className="text-center mb-12">
            <h1 className="text-2xl md:text-3xl lg:text-4xl mx-auto font-black bg-clip-text bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff] mb-4 max-w-3xl leading-snug text-center">
              Diffusion illimitée des derniers films, séries et chaînes de TV en
              direct
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Profitez de contenu premium des meilleures plateformes de
              streaming en un seul abonnement
            </p>
          </div>

          {/* Infinite Carousel */}
          <div className="relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full bg-transparent z-10"></div>
            <div
              ref={carouselRef}
              className="flex space-x-4 overflow-hidden carousel-container"
              style={{
                scrollBehavior: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                touchAction: "none",
                overscrollBehaviorX: "contain",
              }}
              onWheel={blockUserScroll}
              onTouchStart={blockUserScroll}
              onTouchMove={blockUserScroll}
              onPointerDown={blockUserScroll}
              onMouseDown={blockUserScroll}
            >
              {[...filmImages, ...filmImages, ...filmImages].map(
                (image, index) => {
                  return (
                    <div
                      key={`${index}-${Math.random()}`}
                      className="flex-shrink-0 group relative"
                    >
                      <div className="relative w-48 h-80 md:w-52 md:h-[22rem] rounded-2xl overflow-hidden transition-all duration-500 shadow-md mb-2">
                        <img
                          src={image}
                          alt={`Film ${index + 1}`}
                          className="w-full h-full object-cover transition-transform duration-500 carousel-image"
                          draggable={false}
                          onDragStart={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                  );
                }
              )}
            </div>
            {/* Edge fade overlays */}
            <div className="carousel-edge-left"></div>
            <div className="carousel-edge-right"></div>
          </div>
          {/* Streaming Services Grid */}
          <div className="mt-5">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
              {chaineLogos.map((logo, index) => (
                <div
                  key={index}
                  className="group bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 hover:scale-110 border border-gray-100"
                >
                  <div className="flex items-center justify-center h-8">
                    <img
                      src={logo.src}
                      alt={logo.name}
                      className="max-h-12 max-w-full object-contain filter group-hover:brightness-110 transition-all duration-300"
                      loading="lazy"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
